import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scrollable-panel" }
const _hoisted_2 = { class: "scrollable-panel__header" }
const _hoisted_3 = { class: "scrollable-panel__body" }
const _hoisted_4 = { class: "scrollable-panel__header" }

import { ref, onMounted, nextTick } from 'vue';

// ⭕️ 修正2: 親コンポーネントの指定に合わせて `startWidth` ➡️ `leftWidth` に変更

export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollablePanels2',
  props: {
    initialScrollX: { default: 0 },
    leftWidth: { default: 120 }
  },
  setup(__props: any) {

const props = __props;

// ⭕️ 修正3: Vue 3における template ref (this.$refs の代わり) の取得方法
const panelCenter = ref<HTMLDivElement | null>(null);

onMounted(() => {
  const applyScroll = () => {
    const el = panelCenter.value;
    if (el) {
      el.scrollLeft = props.initialScrollX;
    }
  };
  applyScroll();
  if (props.initialScrollX !== 0) {
    nextTick(() => {
      setTimeout(applyScroll, 50);
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "scrollable-panel__wrapper",
    ref_key: "panelCenter",
    ref: panelCenter
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "scrollable-panel__left",
        style: _normalizeStyle({ width: `${__props.leftWidth}px` })
      }, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "left-panel-header")
        ]),
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "left-panel-body")
        ])
      ], 4),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "center-panel-header")
        ]),
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "center-panel-body")
        ])
      ])
    ])
  ], 512))
}
}

})